export enum ResponseApiStatusEnum {
  Created = 0,
  Processing = 1,
  Ready = 2,
  Error = 3,
}
